import { useEffect } from 'react';

import { useI18nContext } from '@/i18n/I18n';
const useHtmlTranslate = () => {
  const [$t, lang] = useI18nContext();

  useEffect(() => {
    const dataTranslateElements = document.querySelectorAll(
      '[data-translate-key]',
    );

    if (dataTranslateElements.length) {
      dataTranslateElements.forEach((el) => {
        el.innerHTML = $t(el.getAttribute('data-translate-key') as string);
      });
    }
  }, [$t, lang]);
};

export default useHtmlTranslate;
